import React from 'react';

import { StyledButton } from './CtaButton.styles';
import { ICtaButtonProps } from './CtaButton.types';

const CtaButton = ({
  children,
  className,
  disabled,
  href,
  rel,
  target,
  title,
  tag = 'button',
  type,
  user = 'neutral',
  variant = 'primary',
  width,
  onClick,
}: ICtaButtonProps): JSX.Element => {
  return (
    <StyledButton
      as={tag}
      className={className}
      disabled={disabled}
      href={href}
      rel={rel}
      target={target}
      title={title}
      type={type}
      user={user}
      variant={variant}
      width={width}
      onClick={onClick}
    >
      {children}
    </StyledButton>
  );
};

export default CtaButton;
